/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2019. All Rights Reserved.
 #*
 #*===================================================================
 */

export interface IPayMethod {
  id: string;
  object: any;
  // ui only
  needsVerification: boolean;
}

export enum PAY_METHOD_TYPE {
  BANK_ACCOUNT = 'bank_account',
  CARD = 'card',
}
export interface IBankAccount extends IPayMethod {
  account_number: string;
  account_holder_name: string;
  account_holder_type: string;
  bank_name: string; // readonly
  country: string;
  currency: string;
  last4: string;
  metadata: any;
  routing_number: string;
  status: string;
}

export interface ICard extends IPayMethod {
  address_city: string;
  address_country: string;
  address_line1: string;
  address_line1_check: string;
  address_line2: string;
  address_state: string;
  address_zip: string;
  address_zip_check: string;
  brand: string;
  country: string;
  cvc_check: string;
  exp_month: number;
  exp_year: number;
  last4: string;
  metadata: any;
  name: string;
  fingerprint: string;
}

export enum BANK_ACCOUNT_STATUS {
  NEW = 'new',
  VALIDATED = 'validated',
  VERIFIED = 'verified',
  VERIFICATION_FAILED = 'verification_failed',
  ERRORED = 'errored',
}

export interface IStripeCustomer {
  sources?: { data: (IBankAccount & ICard)[] };
}
